export default __webpack_public_path__ + "static/media/marks.1c7f51ba.png";